import React, { Component } from "react";
import { Link } from "react-router-dom";
class Header extends Component {
  constructor() {
    super();
    this.state = {
      address: " /",
      menuActive: false
    };
  }
  getAddress() {
    if(this.state.menuActive){
      this.toggleMenu();
    }
    const addressPath = window.location.pathname.split("");
    addressPath.shift();
    addressPath.unshift(" / ");
    this.setState({ address: addressPath.join("") });
    return addressPath;
  }
  toggleMenu() {
    this.setState({ menuActive: !this.state.menuActive });
  }
  render() {
    return (
      <header>
        <nav className="nav" onClick={() => this.getAddress()}>
          <h4>
            <Link
              to="/"
              onMouseEnter={() => this.props.runOnEnter()}
              onMouseLeave={() => {
                this.props.runOnLeave();
              }}
            >
              [ Himanshu Ratnani ]
            </Link>
            {this.state.address}
          </h4>
          <ul className="nav_links">
            <li>
              <Link
                to="/work"
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                Work
              </Link>
            </li>
            <li>
              <Link
                to="/process"
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                My Process
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                Contact
              </Link>
            </li>
          </ul>
          <div className="burgerMenu">
            <i
              className="fa fa-bars fa-2x"
              aria-hidden="true"
              onMouseEnter={() => this.props.runOnEnter()}
              onMouseLeave={() => {
                this.props.runOnLeave();
              }}
              onClick={() => this.toggleMenu()}
            />
          </div>
          {this.state.menuActive === true ? (
            <div className="menu">
              <div className="menuClose">
                <i
                  className="fa fa-times fa-2x"
                  aria-hidden="true"
                  onMouseEnter={() => this.props.runOnEnter()}
                  onMouseLeave={() => {
                    this.props.runOnLeave();
                  }}
                  onClick={() => this.toggleMenu()}
                />
              </div>
              <ul>
                <li>
                  <Link
                    to="/"
                    onMouseEnter={() => this.props.runOnEnter()}
                    onMouseLeave={() => {
                      this.props.runOnLeave();
                    }}
                  >
                    <h1>Home</h1>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/work"
                    onMouseEnter={() => this.props.runOnEnter()}
                    onMouseLeave={() => {
                      this.props.runOnLeave();
                    }}
                  >
                    <h1>Work</h1>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/process"
                    onMouseEnter={() => this.props.runOnEnter()}
                    onMouseLeave={() => {
                      this.props.runOnLeave();
                    }}
                  >
                    <h1>My Process</h1>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    onMouseEnter={() => this.props.runOnEnter()}
                    onMouseLeave={() => {
                      this.props.runOnLeave();
                    }}
                  >
                    <h1>About</h1>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    onMouseEnter={() => this.props.runOnEnter()}
                    onMouseLeave={() => {
                      this.props.runOnLeave();
                    }}
                  >
                    <h1>Contact</h1>
                  </Link>
                </li>
              </ul>
            </div>
          ) : null}
        </nav>
      </header>
    );
  }
}

export default Header;
